import { FLIGHT_UNAVAILABLE_ICON_COLORS, PRICE_CHANGE_ICON_COLORS, PRICE_CHANGE_VARIANT } from './constants'

type IconProps = {
    color?: string
}

export const TrendingDownIcon = ({ color = PRICE_CHANGE_ICON_COLORS[PRICE_CHANGE_VARIANT.DROP].stroke }: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 7L10 14L14 10L21 17M21 17H16M21 17V12"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TrendingUpIcon = ({ color = PRICE_CHANGE_ICON_COLORS[PRICE_CHANGE_VARIANT.INCREASE].stroke }: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 17L10 10L14 14L21 7M21 7H16M21 7V12"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AlertErrorIcon = ({ color = FLIGHT_UNAVAILABLE_ICON_COLORS.stroke }: IconProps) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10.5" stroke={color} strokeWidth="2" />
        <path d="M12 6.5V13" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16.75" r="1.35" fill={color} />
    </svg>
)
